export const m = {
  platform_name: '文档中心',
  changeLangConfirm: '确定切换语言吗？',
  confirmText: '确定',
  cancel: '取消',
  commonTip: '提示',
  cancelManual: '取消了操作',
  application_development_scenario: '应用开发场景',
  overview_of_open_capabilities: '开放能力概览',
  noun_interpretation: '名词解释',
  update_log: '更新日志',
  registered_developer_account: '注册开发者账号',
  create_docking_application: '创建对接应用',
  use_of_frontend_debugging_tools: '前端调试工具使用',
  quick_build_service: '快速构建服务',
  configuration_center: '配置中心',
  security_components: '安全组件',
  log_framework: '日志框架',
  log_collection: '日志采集',
  distributed_tasks: '分布式任务',
  excel_import_and_export: 'Excel导入导出',
  encryption_and_decryption_module: '加解密组件',
  streaming_media: '流媒体',
  file_upload_component: '文件上传组件',
  rich_text_component: '富文本组件',
  online_text_display_component: '在线文本展示组件',
  front_end_permission_component: '前端权限组件',
  behavior_collection_module: '行为采集组件',
  must_read_before_development: '开发前必读',
  open_api_summary: 'Open API 简介',
  interface_debugging: '接口调试',
  summary: '概览',
  unified_authentication: '统一认证',
  single_sign_on: '单点登录',
  get_authorization_code: '获取授权码',
  obtaining_a_token: '获取令牌',
  refresh_token: '刷新令牌',
  get_user_list: '获取用户列表',
  getting_user_information_token: '获取用户信息(Token)',
  getting_user_information_userid: '获取用户信息(UserId)',
  user_name_duplicate_check: '用户名重复校验',
  get_user_organization_information: '获取用户机构信息',
  acquiring_institutions_according_to_id: '根据ID获取机构',
  query_school_list: '查询学校列表',
  query_school_id: '查询学校（ID）',
  query_term_list: '查询学期列表',
  query_timetable_list: '查询作息列表',
  query_class_list: '查询班级列表',
  query_class_id: '查询班级（ID）',
  query_teacher_list: '查询教师列表',
  query_teacher_id: '查询教师（ID）',
  query_teaching_information_list: '查询任教信息列表',
  query_student_list: '查询学生列表',
  query_student_id: '查询学生（ID）',
  query_parents_list: '查询家长列表',
  query_parent_id: '查询家长（ID）',
  query_dictionary_type_list: '查询字典类型列表',
  query_dictionary_information_list: '查询字典信息列表',
  query_weekly_schedule__template_list: '查询周课表（模板）列表',
  query_daily_schedule_list: '查询日课表列表',
  query_teaching_building: '查询教学楼',
  query_classroom: '查询教室',
  query_attendance_information: '查询考勤信息',
  storage_message: '存储消息',
  number_of_unread_messages: '未读消息数',
  view_message_list: '查看消息列表',
  view_session_list: '查看会话列表',
  view_session_messages: '查看会话内消息',
  update_to_read: '更新为已阅',
  removal_message: '删除消息',
  delete_the_session: '删除会话',
  query_unread_message: '查询未读消息',
  java_client_rapid_integration: 'Java客户端快速集成',
  spring_cloud_client_rapid_integration: 'Spring Cloud 客户端快速集成',
  file_upload: '文件上传',
  file_download: '文件下载',
  file_convert: '文件转换',
  get_a_list_of_questions: '获取试题列表',
  get_details_of_questions: '获取试题详情',
  translate: '翻译',
  speech_recognition: '语音识别',
  speech_synthesis: '语音合成',
  word_recognition: '文字识别',
  client_rapid_integration: '客户端快速集成',
  obtaining_authorization: '获取授权',
  update_authorization: '更新授权',
  authorization_recovery: '授权回收',
  apply_for_subscriptions: '申请订阅',
  modify_subscriptions: '修改订阅',
  open_subscribe: '开启订阅',
  unsubscribe: '取消订阅',
  query_subscription: '查询订阅',
  query_text: '贴文查询',
  query_comment: '评论查询',
  query_log: '日志查询',
  kafka_message: 'Kafka消息',
  sdk_download: 'SDK下载',
  error_code_specification: '错误码规范',
  global_error_code: '全局错误码',
  interface_call_problem: '接口调用问题',
  access_problem: '接入问题',
  user_problem: '用户问题',
  business_problems: '业务问题',
  default_title: '默认文档',
  common_problem: '常见问题',
  identity_check: '身份验证',
  basic_data_api: '基础数据API',
  curriculum_schedule: '课程表',
  attendance_interface: '考勤接口',
  message_center: '消息中心',
  file_service: '文件服务',
  question_service: '试题服务',
  ai_service: 'AI服务',
  opinion_service: '舆情服务',
  instant_message: '即时消息',
  error_code: '错误码',
  service: '服务',
  front_end_component: '前端组件',
  dev_ready: '开发准备',
  quick_start: '快速入门',
  frame: '框架',
  open_api: '开放API',
  input_key: '请输入关键字',
  update_time: '更新时间',
  editor: '编辑',
  upload_file: '上传文件',
  save: '保存',
  cancle: '取消',
  support_file_type_info: '支持上传文件类型：图片、office文档、视频文件',
  introduce: '平台介绍',
  design: '规范设计',
  integrate: '应用接入',
  logout: '退出',
  login: '登录',
  design_principles: '设计原则',
  concise_and_clear: '简洁清晰',
  flexible_and_efficient: '灵活高效',
  user_control: '用户控制',
  visual_norms: '视觉规范',
  layout: '布局',
  color: '色彩',
  font: '字体',
  icon: '图标',
  button: '按钮',
  loginAccountPlaceHolder: '请输入登录帐号、手机号或邮箱',
  inputPwdTip: '请输入密码',
  selectOrgTip: '请选择机构',
  yzmPlaceHolder: '请输入验证码',
  yzmEmptyTip: '必须填写验证码',
  changeAnother: '换一张',
  loginFailed: '登录失败，请联系管理员',
  selectSuiteBroseTip: '请用IE9以上的浏览器或谷歌、火狐等适用的浏览器',
  loginNameRepeatTip: '登录名重复请选择自己的用户登录',
  userStatusNotCorrectTip: '该用户不是正常状态，请联系管理员',
  userNotExistTip: '用户名不存在',
  loginPwdError: '密码错误',
  loginNameInputTip: '请输入用户名',
  checkCodeError: '验证码错误',
  getCheckcodeError: '获取验证码失败',
  xwqqlogin: '微信QQ登录',
  operation: '运营中心',
  addGoods: '新增商品',
  modifyGoods: '修改商品',
  queryGoods: '查询商品',
  saveOrder: '生成订单',
  cancelOrder: '取消订单',
  queryOrder: '查询订单',
  ssoFailed: '登录失败',
  payService: '支付服务',
  howtoLogin: '如何登录？',
  howtoFindPwd: '如何找回密码？',
  xtbg: '智慧办公',
  xtsyxd: '系统使用向导',
  wjdc: '问卷调查',
  zymgnjs: '主页面布局及功能介绍',
  xtsz: '系统设置',
  dzgrzy: '如何定制个人主页',
  glbmyhxx: '管理部门和用户信息',
  kqgzsz: '考勤规则设置',
  lczx: '流程中心',
  lcfqxj: '发起新建',
  lcwddb: '我的待办',
  jbgz: '经办跟踪',
  lscx: '历史查询',
  xzbg: '行政办公',
  rw: '任务',
  grrwzy: '个人任务主页',
  rwxm: '项目',
  rwdt: '动态',
  dcwj: '调查问卷',
  cjwj: '创建问卷',
  hswj: '回收问卷',
  wjcx: '问卷查询&删除',
  ckwjdt: '查看问卷答题情况',
  txwj: '填写问卷',
  kmwp: 'KM网盘（知识管理）',
  kmgnjs: 'km功能介绍',
  kmqxqb: 'km不同角色使用网盘权限的区别',
  kmdlfs: '登录km网盘的方式',
  kmsy: '首页',
  kmgrwp: '个人网盘',
  kmggwp: '公共网盘',
  znxxgg: '站内消息和公告',
  xxrk: '入口',
  xtxx: '系统消息',
  yhxx: '用户消息',
  xxgg: '公告',
  fbwj: '发布问卷',
  wjhswj: '回收答卷',
  wjfxxz: '分析&下载',
  tjfxxz: '统计与分析',
  ckxzdj: '查看下载答卷',
  wjfz: '问卷复制',
  wjsc: '问卷删除',
  wjzx: '问卷中心',
  wjcjwj: '创建问卷',
  wjsjwj: '设计问卷',
  wjsz: '问卷设置',
  wjwgsz: '外观设置',
  czwdxz: '操作手册下载',
  developer_platform: '开发平台',
  BusinessAPP: '业务应用',
  document_menu_management: '文档菜单管理',
  zwwd: '暂无文档',
  cdlmsz: '菜单栏目设置',
  menuName: '菜单名称',
  superior: '上级',
  selectTop: '选择上级',
  nothing: '无',
  sortNum: '排序',
  appType: '应用类型',
  appTypeTeching: '教学应用',
  appTypeStudy: '学习应用',
  appTypeManage: '管理应用',
  appTypeEvaluate: '评价应用',
  appTypeResearch: '教研应用',
  appTypeResource: '资源应用',
  appTypeOther: '其他应用',
  appTypeClass: '课堂应用',
  appTypeOtherTools: '授课工具',
  qsycdmc: '请输入菜单名称',
  qsrxh: '请输入序号',
  bccg: '保存成功',
  add: '新增',
  kfjk: '开放接口',
  common: '共',
  ssjg: '个搜索结果',
  mycxdjl: '没有查询到符合条件的记录',
  twtymyapi: '天闻统一门户平台API',
  twzjk: '天闻组件库',
  yhtx: '用户头像'
}



// WEBPACK FOOTER //
// ./src/lang/zh.js